import {
    Row, Col, Typography, Button, Divider,
    Form, Input
} from 'antd';
import { DollarCircleOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';

import { colFull, colInputs8 } from './GridStyle';
import LayoutDashboard from '../../../../../layout/LayoutAdmin';
import { Loading } from '../../../../../components/Loading';
import { useCertidoesAddOrUpdate } from './useAddOrUpdate';

const { Text, Title, Link } = Typography;

const RecargasCongelamentoAddOrUpdate = () => {

    let { id } = useParams();

    const {
        loading,
        estaEditando,
        navigate,
        refForm,
        submitBotaoEditar,
        submitBotaoSalvar,
        onChangeInputFormatMoney,
    } = useCertidoesAddOrUpdate({ id })

    return (
        <LayoutDashboard>
            <Loading

                loading={loading}
            >
                <Row>
                    <Col {...colFull}>
                        <Title level={4}>
                            <DollarCircleOutlined style={{ fontSize: 23, marginRight: 10 }} />
                            {`${estaEditando ? 'Editar' : 'Adicionar'} Recarga`}
                        </Title>
                        <div
                            style={{
                                display: 'flex'
                            }}
                        >
                            <Link
                                onClick={() => [
                                    navigate('/congelamento-cnpj/recargas')
                                ]}
                                style={{
                                    marginRight: 5
                                }}
                            >
                                <Text
                                    type='secondary' underline
                                >Recargas</Text>
                            </Link>

                            <Text
                                style={{
                                    marginRight: 5
                                }} type='secondary'
                            >/</Text>

                            <Text style={{
                                marginRight: 5
                            }}>{`${estaEditando ? 'Editar' : 'Adicionar'}`}</Text>
                        </div>
                        <Divider />
                    </Col>
                </Row>

                <Form
                    ref={refForm}
                    name="adicionarRecarga"
                    layout="vertical"
                    initialValues={{
                        remember: true,
                    }}
                    autoComplete="off"
                >
                    <Row>
                        <Col {...colInputs8}>
                            <Form.Item
                                style={{
                                    margin: 5
                                }}
                                name="valor"
                                label="Valor"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor, digite o valor.',
                                    },
                                ]}
                            >
                                <Input
                                    autoComplete="off"
                                    placeholder="1.000"
                                    prefix="R$"
                                    onChange={onChangeInputFormatMoney}
                                />
                            </Form.Item>
                        </Col>
                        <Col {...colFull}>
                            <div className="botaoSalvarStep" style={{
                                flexDirection: 'row',
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}>
                                <Button
                                    style={{
                                        marginTop: 20
                                    }}
                                    onClick={() => {
                                        navigate('/congelamento-cnpj/recargas')
                                    }}
                                >
                                    {"Voltar"}
                                </Button>
                                <Button
                                    key="submit"
                                    type="primary"
                                    style={{
                                        marginLeft: 5,
                                        marginTop: 20,
                                    }}
                                    onClick={() => {
                                        estaEditando ?
                                            submitBotaoEditar(id ? id : 'criar')
                                            :
                                            submitBotaoSalvar()
                                    }}
                                >
                                    {"Salvar"}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Loading>
        </LayoutDashboard >
    );
}

export default RecargasCongelamentoAddOrUpdate;
